<mat-card class="item" *ngIf="task" (dblclick)="edit.emit(task)">
  <h2><img src="https://img.icons8.com/ios/24/ffffff/beam-pro--v1.png"/> {{ task.title }}</h2>
  <p>
    {{ task.description }}
  </p>
  <hr>
</mat-card>
